import type { FC, ReactNode } from "react";
import { CalculatorLeadActions } from "web_myplann/Calculators/Components/CalculatorLeadActions";
import { CalculatorResultBadge } from "web_myplann/Calculators/Components/CalculatorResultBadge";
import { CalculatorResultRows } from "web_myplann/Calculators/Components/CalculatorResultRows";
import { CalculatorResultSurface } from "web_myplann/Calculators/Components/CalculatorResultSurface";
import type { CalculatorLeadState } from "web_myplann/Calculators/Types/CalculatorLeadState";
import type { CalculatorResultRow } from "web_myplann/Calculators/Types/CalculatorResultRow";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	badge: string;
	hero: ReactNode;
	rows?: CalculatorResultRow[];
	waitingNote?: ReactNode;
	comparison?: ReactNode;
	lead: CalculatorLeadState;
};

export const CalculatorResultSection: FC<Props> = ({
	badge,
	hero,
	rows,
	waitingNote,
	comparison,
	lead,
}) => {
	const { t } = useResource();

	return (
		<CalculatorResultSurface>
			<CalculatorResultBadge label={badge} />
			{hero}
			{rows && rows.length > 0 && <CalculatorResultRows rows={rows} />}
			{waitingNote}
			{comparison}
			<CalculatorLeadActions
				hint={
					comparison
						? t(Resources.Calculators.Result.CompareFooter)
						: t(Resources.Calculators.Result.LeadHint)
				}
				lead={lead}
			/>
		</CalculatorResultSurface>
	);
};
